// @desc - to show Employee name and ID
// props - user object containing first name, last name and ID

import React from "react";
import PropTypes from "prop-types";
import { Typography, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  id: {
    marginBottom: theme.space.bottom,
    color: theme.palette.primary.dark,
  },
}));

const Employee = (props) => {
  const classes = useStyles();
  const { user } = props;

  return (
    <>
      <Typography variant="h6">
        {user.firstName} {user.lastName}
      </Typography>
      <Typography variant="subtitle2" className={classes.id}>
        {user.workerId}
      </Typography>
    </>
  );
};

Employee.propTypes = {
  user: PropTypes.object.isRequired,
};

export default Employee;
